import { Component, OnInit } from '@angular/core';
import { DeviceService } from './@core/services/device.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
  constructor(private deviceService: DeviceService) {}

  ngOnInit() {
    if (sessionStorage.getItem('token') || sessionStorage.getItem('loggedUser')) {
      this.deviceService.initDevice();
    }
  }
}
